<template lang='pug'>
.reports-root.container
  template(v-if='$route.path === "/reports"')
    h1 报表
    rooms
  router-view
</template>

<script>
import Rooms from './Rooms.vue'

export default {
  name: 'reports-root',
  components: { Rooms },
}
</script>



// WEBPACK FOOTER //
// Root.vue?e06e25b8